import { SearchFormGoalName, type SearchFormGoal } from '@/entities/searchForm';

// Повторный клик по активному ±N и «Точные даты» гибкость снимают — это не выбор, цель не нужна.
export function getFlexibleClickGoal(selected: number, current: number): SearchFormGoal | null {
  if (selected <= 0 || selected === current) {
    return null;
  }
  return { name: SearchFormGoalName.FlexibleClick, params: { daysFlexible: selected } };
}
